import { UPDATE_TOKENS_FROM_INTERCEPTOR } from './types';

export const updateTokensFromInterceptor = tokens => ({
  type: UPDATE_TOKENS_FROM_INTERCEPTOR,
  tokens,
});

export default updateTokensFromInterceptor;
